import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './app/App'
import { AppStoreProvider } from './store/AppStore'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><BrowserRouter><AppStoreProvider><App/></AppStoreProvider></BrowserRouter></React.StrictMode>,
)
